import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Apre una sessione di upload da smartphone per la scheda prodotto aperta.
	// Ritorna { token, room, url, qr, expiresAt, ttl, maxFiles } oppure { error }.
	createSession: async (context, payload) => {
		let url = 'qrupload/session';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					uuid: payload.uuid,
					folder: payload.folder || 'items',
					// ocr: dalla foto si legge il testo per la descrizione, la foto non viene salvata
					mode: payload.mode || 'images',
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	// Stato della sessione: usato per riallineare la lista immagini quando il
	// socket e' caduto e qualche evento e' andato perso.
	fetchSession: async (context, token) => {
		let url = `qrupload/session/${token}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	revokeSession: async (context, token) => {
		let url = `qrupload/session/${token}/revoke`;

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				},
			)
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
